import { Component, Input } from '@angular/core';
import { GalleryImageModel } from 'src/app/models/gallery-image-model';

@Component({
  selector: 'app-gallery-img',
  templateUrl: './gallery-img.component.html',
  styleUrls: ['./gallery-img.component.scss']
})
export class GalleryImgComponent {
  @Input() items: GalleryImageModel[];
  activeId: number;

  constructor() {
    this.activeId = 1;
  }
}
